export const GET_FLOW_FILES_REQUEST = 'GET_FLOW_FILES_REQUEST';
export const GET_FLOW_FILES_SUCCESS = 'GET_FLOW_FILES_SUCCESS';
export const GET_FLOW_FILES_ERROR = 'GET_FLOW_FILES_ERROR';
export const GET_FLOW_FILE_REQUEST = 'GET_FLOW_FILE_REQUEST';
export const GET_FLOW_FILE_SUCCESS = 'GET_FLOW_FILE_SUCCESS';
export const GET_FLOW_FILE_ERROR = 'GET_FLOW_FILE_ERROR';
export const ADD_FLOW_FILE_REQUEST = 'ADD_FLOW_FILE_REQUEST';
export const ADD_FLOW_FILE_SUCCESS = 'ADD_FLOW_FILE_SUCCESS';
export const ADD_FLOW_FILE_ERROR = 'ADD_FLOW_FILE_ERROR';
export const UPLOAD_FLOW_FILES_REQUEST = 'UPLOAD_FLOW_FILES_REQUEST';
export const UPLOAD_FLOW_FILE_REQUEST = 'UPLOAD_FLOW_FILE_REQUEST';
export const UPLOAD_FLOW_FILE_SUCCESS = 'UPLOAD_FLOW_FILE_SUCCESS';
export const UPLOAD_FLOW_FILE_ERROR = 'UPLOAD_FLOW_FILE_ERROR';
export const UPLOAD_FLOW_FILES_SUCCESS = 'UPLOAD_FLOW_FILES_SUCCESS';
export const UPLOAD_FLOW_FILES_ERROR = 'UPLOAD_FLOW_FILES_ERROR';
export const UPDATE_FLOW_FILE_REQUEST = 'UPDATE_FLOW_FILE_REQUEST';
export const UPDATE_FLOW_FILE_SUCCESS = 'UPDATE_FLOW_FILE_SUCCESS';
export const UPDATE_FLOW_FILE_ERROR = 'UPDATE_FLOW_FILE_ERROR';
export const ADD_FLOW_NEW_FILE = 'ADD_FLOW_NEW_FILE';
export const DELETE_FLOW_FILE_REQUEST = 'DELETE_FLOW_FILE_REQUEST';
export const DELETE_FLOW_FILE_SUCCESS = 'DELETE_FLOW_FILE_SUCCESS';
export const DELETE_FLOW_FILE_ERROR = 'DELETE_FLOW_FILE_ERROR';
export const EXPORT_FLOW_FILE_REQUEST = 'EXPORT_FLOW_FILE_REQUEST';
export const EXPORT_FLOW_FILE_SUCCESS = 'EXPORT_FLOW_FILE_SUCCESS';
export const EXPORT_FLOW_FILE_ERROR = 'EXPORT_FLOW_FILE_ERROR';
export const SET_FLOW_DEFAULT_PERCENTAGE_TO_FILE =
  'SET_FLOW_DEFAULT_PERCENTAGE_TO_FILE';
export const RESET_FLOW_UPLOAD_FILES = 'RESET_FLOW_UPLOAD_FILES';
export const UPDATE_FLOW_SEARCH_TERM = 'UPDATE_FLOW_SEARCH_TERM';
export const CLOSE_FLOW_FILE = 'CLOSE_FLOW_FILE';
export const UPDATE_FLOW_BLOB_REQUEST = 'UPDATE_FLOW_BLOB_REQUEST';
export const UPDATE_FLOW_BLOB_SUCCESS = 'UPDATE_FLOW_BLOB_SUCCESS';
export const UPDATE_FLOW_BLOB_ERROR = 'UPDATE_FLOW_BLOB_ERROR';
export const UPDATE_FLOW_EDITOR_SEARCH_TERM = 'UPDATE_FLOW_EDITOR_SEARCH_TERM';
export const SET_FLOW_THEME = 'SET_FLOW_THEME';
export const OPEN_FLOW_FILE = 'OPEN_FLOW_FILE';

export const DELETE_FLOW_FILES_REQUEST = 'DELETE_FLOW_FILES_REQUEST';
export const DELETE_FLOW_FILES_SUCCESS = 'DELETE_FLOW_FILES_SUCCESS';
export const DELETE_FLOW_FILES_ERROR = 'DELETE_FLOW_FILES_ERROR';
export const EXPORT_FLOW_FILES_REQUEST = 'EXPORT_FLOW_FILES_REQUEST';
export const EXPORT_FLOW_FILES_SUCCESS = 'EXPORT_FLOW_FILES_SUCCESS';
export const EXPORT_FLOW_FILES_ERROR = 'EXPORT_FLOW_FILES_ERROR';
export const OPEN_FLOW_FILES_REQUEST = 'OPEN_FLOW_FILES_REQUEST';
export const OPEN_FLOW_FILES_SUCCESS = 'OPEN_FLOW_FILES_SUCCESS';
export const OPEN_FLOW_FILES_ERROR = 'OPEN_FLOW_FILES_ERROR';

export const EXPORT_FLOW_ALL_FILES_AND_FOLDERS_REQUEST =
  'EXPORT_FLOW_ALL_FILES_AND_FOLDERS_REQUEST';
export const EXPORT_FLOW_ALL_FILES_AND_FOLDERS_SUCCESS =
  'EXPORT_FLOW_ALL_FILES_AND_FOLDERS_SUCCESS';
export const EXPORT_FLOW_ALL_FILES_AND_FOLDERS_ERROR =
  'EXPORT_FLOW_ALL_FILES_AND_FOLDERS_ERROR';

export const ADD_FLOW_FOLDER_REQUEST = 'ADD_FLOW_FOLDER_REQUEST';
export const ADD_FLOW_FOLDER_SUCCESS = 'ADD_FLOW_FOLDER_SUCCESS';
export const ADD_FLOW_FOLDER_ERROR = 'ADD_FLOW_FOLDER_ERROR';

export const UPDATE_FLOW_FOLDER_REQUEST = 'UPDATE_FLOW_FOLDER_REQUEST';
export const UPDATE_FLOW_FOLDER_SUCCESS = 'UPDATE_FLOW_FOLDER_SUCCESS';
export const UPDATE_FLOW_FOLDER_ERROR = 'UPDATE_FLOW_FOLDER_ERROR';

export const DELETE_FLOW_FOLDER_REQUEST = 'DELETE_FLOW_FOLDER_REQUEST';
export const DELETE_FLOW_FOLDER_SUCCESS = 'DELETE_FLOW_FOLDER_SUCCESS';
export const DELETE_FLOW_FOLDER_ERROR = 'DELETE_FLOW_FOLDER_ERROR';

export const EXPORT_FLOW_FILE_OR_FOLDER_REQUEST =
  'EXPORT_FLOW_FILE_OR_FOLDER_REQUEST';
export const EXPORT_FLOW_FILE_OR_FOLDER_SUCCESS =
  'EXPORT_FLOW_FILE_OR_FOLDER_SUCCESS';
export const EXPORT_FLOW_FILE_OR_FOLDER_ERROR =
  'EXPORT_FLOW_FILE_OR_FOLDER_ERROR';

export const SYNC_FLOW_FILES_REQUEST = 'SYNC_FLOW_FILES_REQUEST';
export const SYNC_FLOW_FILES_SUCCESS = 'SYNC_FLOW_FILES_SUCCESS';
export const SYNC_FLOW_FILES_ERROR = 'SYNC_FLOW_FILES_ERROR';

export const RENAME_FLOW_FOLDER_REQUEST = 'RENAME_FLOW_FOLDER_REQUEST';
export const RENAME_FLOW_FOLDER_SUCCESS = 'RENAME_FLOW_FOLDER_SUCCESS';
export const RENAME_FLOW_FOLDER_ERROR = 'RENAME_FLOW_FOLDER_ERROR';

export const RENAME_FLOW_FILE_REQUEST = 'RENAME_FLOW_FILE_REQUEST';
export const RENAME_FLOW_FILE_SUCCESS = 'RENAME_FLOW_FILE_SUCCESS';
export const RENAME_FLOW_FILE_ERROR = 'RENAME_FLOW_FILE_ERROR';

export const CREATE_TEMP_FILE = 'CREATE_TEMP_FILE';
export const CREATE_TEMP_FOLDER = 'CREATE_TEMP_FOLDER';
export const PERSIST_TEMPORARY_ITEM_SUCCESS = 'PERSIST_TEMPORARY_ITEM_SUCCESS';
export const PERSIST_TEMPORARY_ITEM_FAILURE = 'PERSIST_TEMPORARY_ITEM_FAILURE';
